import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AnexoListaEnvioComponent} from '../anexo-lista-envio/anexo-lista-envio.component';
import {ListaContatosComponent} from '../lista-contatos/lista-contatos.component';
import {ContatosBaseDadosComponent} from '../contatos-base-dados/contatos-base-dados.component';
import {DisparoAutomaticoModel} from '../../../../shared/model/disparo-automatico/disparo-automatico.model';
import {TabelaSkeletonComponent} from '../../../../shared/components/tabela-skeleton/tabela-skeleton.component';
import {IntegracaoDisparoComponent} from '../integracao-disparo/integracao-disparo.component';
import {DisparoIntegracaoModel} from '../../../../shared/model/disparo-automatico/disparo-integracao.model';
import { SlideTogglePadraoComponent } from "../../../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component";
import { DisparoAutomaticoVariavelModel } from '../../../../shared/model/disparo-automatico/disparo-automatico-variavel.model';

@Component({
  selector: 'app-lista-envio-contatos',
  standalone: true,
  imports: [
    AnexoListaEnvioComponent,
    ListaContatosComponent,
    ContatosBaseDadosComponent,
    TabelaSkeletonComponent,
    IntegracaoDisparoComponent,
    SlideTogglePadraoComponent
],
  templateUrl: './lista-envio-contatos.component.html',
  styleUrl: './lista-envio-contatos.component.css'
})
export class ListaEnvioContatosComponent implements OnInit, OnChanges {
  @Input() disparoAutomatico: DisparoAutomaticoModel = new DisparoAutomaticoModel();
  @Input() statusDisparo?: string;
  @Input() anexo: any;
  @Input() setorId?: number;
  @Input() carregandoInicial = false;
  @Input() variaveis: DisparoAutomaticoVariavelModel[] = [];
  @Input() exibirReenvioIntegracao = false;
  @Input() reenviandoIntegracao = false;

  @Output() envioAnexo = new EventEmitter<any>();
  @Output() colunasComplementaresAtualizadas = new EventEmitter<string[]>();
  @Output() contatosPreviewAtualizados = new EventEmitter<any[]>();
  @Output() reenviarIntegracao = new EventEmitter<void>();

  origem: 'EXCEL' | 'BASE_DINAMICA' = 'EXCEL';
  realizarIntegracao = false;

  ngOnInit() {
    this.sincronizarComDisparo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disparoAutomatico'] && !changes['disparoAutomatico'].firstChange) {
      this.sincronizarComDisparo();
    }
  }

  private sincronizarComDisparo(): void {
    this.origem = this.disparoAutomatico.origemContatos ?? 'EXCEL';
    this.disparoAutomatico.origemContatos = this.origem;
    this.realizarIntegracao = this.disparoAutomatico.integracao != null;
  }

  get podeEditar(): boolean {
    if (this.disparoAutomatico.ehProgramacaoRecorrente) {
      return (this.disparoAutomatico.programacao?.enviosRealizados ?? this.disparoAutomatico.quantidadeEnvios ?? 0) < 1;
    }
    const status = this.disparoAutomatico.status;
    return !status || status === 'Agendado' || status === 'Aguardando Envio';
  }

  get disparoIdParaCarregarContatos(): number | null {
    if (this.disparoAutomatico.ehProgramacaoRecorrente || this.anexo?.existente !== true) {
      return null;
    }
    return this.disparoAutomatico.id ?? null;
  }

  selecionarAba(origem: 'EXCEL' | 'BASE_DINAMICA') {
    if (!this.podeEditar) {
      return;
    }
    this.origem = origem;
    this.disparoAutomatico.origemContatos = origem;

    if (origem === 'EXCEL') {
      this.colunasComplementaresAtualizadas.emit(this.anexo?.colunasComplementares ?? []);
      this.contatosPreviewAtualizados.emit(this.anexo?.listaContatos ?? []);
    } else {
      this.colunasComplementaresAtualizadas.emit([]);
      this.contatosPreviewAtualizados.emit([]);
    }
  }

  receberAnexo(anexo: any): void {
    this.anexo = anexo;
    this.envioAnexo.emit(anexo);
    this.contatosPreviewAtualizados.emit(anexo?.listaContatos ?? []);
  }

  receberColunasComplementares(colunas: string[]) {
    this.colunasComplementaresAtualizadas.emit(colunas);
  }

  alterarRealizarIntegracao(habilitada: boolean): void {
    if (!this.podeEditar) return;
    this.realizarIntegracao = habilitada;
    if (habilitada) {
      this.disparoAutomatico.integracao ??= new DisparoIntegracaoModel();
      this.disparoAutomatico.integracao.personalizada = false;
    } else {
      this.disparoAutomatico.integracao = undefined;
    }
  }
}
